import sha256 from 'js-sha256'

const zmTranslate = {};

const appInfo = {
    baseUrl:'http://openapi.youdao.com/api',
    // appKey:'55778c2b68a90e00',
    // key:'xiQWHmaMoPFZfyW6Nien58ikrx7cztMC'
    appKey:'3a332a339ba4c164',
    key:'QqFdkWxry1aMFCMEEUugUoYrUiSUz9md'
};

const truncate = function(q){
    let len = q.length;
    if(len<=20) {
        return q;
    }
    return q.substring(0, 10) + len + q.substring(len-10, len);
};

const getParams = function (text, lang) {
    let to  = lang ? lang : 'en';
    let salt = new Date().getTime();
    let curTime = Math.round(new Date().getTime()/1000);

    let str1 = appInfo.appKey + truncate(text) + salt + curTime + appInfo.key;
    let sign = sha256.sha256(str1);
    return {
        q:text,
        appKey:appInfo.appKey,
        salt:salt,
        from:'auto',
        to:to,
        sign: sign,
        signType: 'v3',
        curtime: curTime
    }
};

zmTranslate.translate = function (text, lang) {
    return new Promise((resolve,reject) => {
        if(text){
            let enFlag = false;
            if(!lang || lang == 'en'){
                enFlag = /.*[\u4e00-\u9fa5]+.*$/.test(text);

                // enFlag = /^[a-z A-Z]+$/.test(text);
            }
            if(enFlag){
                try {
                    jQuery.ajax({
                        url: 'http://openapi.youdao.com/api',
                        type: 'post',
                        dataType: 'jsonp',
                        data: getParams(text,lang),
                        success: function (data) {
                            if(data.translation && data.translation.length > 0){
                                resolve(data.translation[0]);
                            }else{
                                resolve(text);
                            }
                        }
                    });
                } catch(e) {
                    reject();
                }
            }else{
                resolve(text)
            }
        }else{
            resolve('');
        }
    })
};







export default zmTranslate;


// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/utils/baiduTranslate.js